import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { TipoArquivoSituacaoModule } from '../situacao';
import { ArquivoReferenciaMultiselectModule } from '../../referencias/components/multiselect';

import { TipoArquivoFilterComponent } from './tipo-arquivo-filter.component';

@NgModule({
    imports: [
        SharedModule,
        TipoArquivoSituacaoModule,
        ArquivoReferenciaMultiselectModule
    ],
    declarations: [
        TipoArquivoFilterComponent
    ],
    exports: [
        TipoArquivoFilterComponent
    ]
})
export class TipoArquivoFilterModule { }
